/**
 * This file holds functions that performs actual state modifications
 * Please refer to https://vuex.vuejs.org/guide/mutations.html for more information
 */
import * as types from "./types";

const mutations = {
  [types.SET_ENDPOINTS](state, { endpoints, type }) {
    state[type] = {
      ...state[type],
      ...endpoints
    };
  },
  [types.SET_PUBLIC_PATH](state, payload) {
    const path = payload.replace()
    state.publicPath = payload;
  }
};

export default mutations;
